import React, { FC, useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Menu from '@mui/material/Menu';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { Avatar, Badge, styled } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import LogoutIcon from '@mui/icons-material/Logout';
import { AuthService } from '../../Services/AuthService';
import { OrganizationNameCard, OrganizationNameHeader, UserInfoCardContainer, UserInfoHeaderContainer, UserNameCard } from './Header.styled';

const authService = new AuthService();
const settings = ['Hjálp', 'Skrá út'];

interface HeaderProps {
  desktopView: boolean;
  hideUserInfo?: boolean;
}

const Header: FC<HeaderProps> = (props) => {
  const [showBanner, setShowBanner] = useState(false);

    useEffect(() => {
      const checkMaintenanceWindow = () => {
        const now = new Date();
        const maintenanceWindows = [
          { start: new Date('2026-01-22T16:30:00Z'), end: new Date('2026-01-22T19:00:00Z') }, // 18:00-20:00 CET
          { start: new Date('2026-01-24T16:30:00Z'), end: new Date('2026-01-24T20:55:00Z') }, // 18:00-21:55 CET
          { start: new Date('2026-01-26T18:30:00Z'), end: new Date('2026-01-27T00:55:00Z') }, // 20:00-01:55 CET
          { start: new Date('2026-02-16T13:45:00Z'), end: new Date('2026-02-16T14:45:00Z') }, // 14::45-15:45 CET
        ];

        const isInMaintenanceWindow = maintenanceWindows.some(
          window => now >= window.start && now <= window.end
        );

        setShowBanner(isInMaintenanceWindow);
      };

      checkMaintenanceWindow();
      const interval = setInterval(checkMaintenanceWindow, 60000); // Check every minute

      return () => clearInterval(interval);
    }, []);

  const [anchorElUser, setAnchorElUser] = useState<null | HTMLElement>(null);
  const [actorName, setActorName] = useState<string | null>(null);
  const [exporterName, setExporterName] = useState<string | null>(null);

  useEffect(() => {
    async function fetchUser() {
      const user = await authService.getUser();
      setExporterName(user?.profile?.name ?? null);
      if (user?.profile?.actor !== null) {
        setActorName((user?.profile?.actor as { name: string })?.name);
      }
    }
    fetchUser();
  }, []);

  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const SmallAvatar = styled(Avatar)(() => ({
    width: 8,
    height: 8,
    backgroundColor: '#3a3b3c',
    border: '4px solid #3a3b3c'
  }));

  return (
    <AppBar position="static">
      <Toolbar sx={{ display: 'flex', justifyContent: 'space-between', height: '1em', bgcolor: 'black' }} variant='dense'>
        <Box sx={{ display: 'flex', flexDirection: 'row', cursor: 'pointer' }} onClick={() => document.location.href = props?.hideUserInfo ? '' : '/veidivottord'}>
          <img style={{ paddingRight: '1em', height: '2em', width: '2em', paddingTop: '1em' }} alt="logo" src="https://images.ctfassets.net/8k0h54kbe6bj/3W68zG8kVqVY7DU1qHxVEA/4d403503b05488cc8385578a92ef399e/fiskist-merki_2x.png"></img>
            <h3>{window.location.pathname.includes('confirmed-certificates') ? 'Icelandic Catch Certificate' : 'Veiðivottorð'}</h3>
        </Box>

        {props?.hideUserInfo !== true &&
          (
            <Box>
              <Tooltip title="">
                <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                  {props.desktopView &&
                    <UserInfoHeaderContainer>
                      <OrganizationNameHeader>{exporterName}</OrganizationNameHeader>
                    </UserInfoHeaderContainer>
                  }
                  <Badge
                    overlap="circular"
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                    badgeContent={
                      <SmallAvatar>
                        <ExpandMoreIcon />
                      </SmallAvatar>
                    }
                  >
                    <Avatar sx={{ height: '2em', width: '2em', bgcolor: '#1976d2', fontSize: '0.65em', border: '2px solid #1976d2' }}>{exporterName?.length ? exporterName[0] : 'N'}</Avatar>
                  </Badge>
                </IconButton>
              </Tooltip>
              <Menu
                sx={{ mt: '45px' }}
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
              >
                <UserInfoCardContainer>
                  <Avatar sx={{ left: 'calc(50% - 2em)', height: '4em', width: '4em', bgcolor: '#1976d2' }}>{exporterName?.length ? exporterName[0] : 'N'}</Avatar>
                  <OrganizationNameCard>{exporterName}</OrganizationNameCard>
                  {actorName !== null ? <UserNameCard>{actorName}</UserNameCard> : null}
                </UserInfoCardContainer>
                {settings.map((setting) => (
                  <MenuItem 
                  key={setting} 
                  onClick={() => {
                    if (setting === 'Skrá út') {
                    authService.logout();
                    } else if (setting === 'Hjálp') {
                    window.open('/help');
                    }
                  }}
                  >
                  {setting === 'Skrá út' ? (
                    <LogoutIcon style={{ marginRight: '10px' }} />
                  ) : (
                    <Box component="span" sx={{ width: '24px', marginRight: '10px', textAlign: 'center' }}>?</Box>
                  )}
                  <Typography textAlign="center">{setting}</Typography>
                  </MenuItem>
                ))}
              </Menu>
            </Box>
          )
        }

      </Toolbar>
      {showBanner && (
        <Box sx={{ 
          bgcolor: '#ff9800', 
          color: 'white', 
          padding: '8px 16px', 
          textAlign: 'center',
          fontSize: '14px'
        }}>
            <Typography variant="body2">
            ⚠️ Viðhaldsvinna á TRACES kerfi ESB stendur yfir. Áætlaðar niðurtími: 16/02 14:00-14:45.
            </Typography>
        </Box>
      )}
    </AppBar>
  );
}

export default Header;
